__turbopack_context__.v({
  "button": "NewRoomButton-module-sass-module__bNnRyG__button" + " " + __turbopack_context__.i(91123)["button"],
  "buttonFooter": "NewRoomButton-module-sass-module__bNnRyG__buttonFooter",
  "buttonHeader": "NewRoomButton-module-sass-module__bNnRyG__buttonHeader",
  "buttonHeaderText": "NewRoomButton-module-sass-module__bNnRyG__buttonHeaderText",
});
